import { render } from "./Endereco.vue?vue&type=template&id=4b28b70a&ts=true"
import script from "./Endereco.vue?vue&type=script&lang=ts"
export * from "./Endereco.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__